<template>
  <div class="wrap">
    <el-card class="boxCard">
      <div slot="header" class="clearfix">
        <span>授权并发布小程序</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="16">
          <div style="height: 300px;">
            <el-steps direction="vertical" class="stepLine">
              <el-step title="步骤 1" status="process">
                <div class="description" slot="description">
                  使用微信小程序管理员账号登录并扫码，在授权过程中，请勾选所有权限确保小程序能完整使用<br />
                  如未注册，请前往 <el-link type="primary" href="https://kf.qq.com/faq/170109iQBJ3Q170109JbQfiu.html" target="_blank" rel="noopener noreferrer">注册</el-link>
                </div>
              </el-step>
              <el-step title="步骤 2" status="process">
                <div class="description" slot="description">
                  请前往微信官方平台将商户号与小程序关联，查看关联<el-link type="primary" href="https://kf.qq.com/faq/180910QZzmaE180910vQJfIB.html" target="_blank" rel="noopener noreferrer">教程</el-link>，关联成功后，请提供商户号和API密钥实现微信支付功能。
                </div>
              </el-step>
              <el-step title="步骤 3" status="process">
                <div class="description" slot="description">
                  提交微信审核（最长14个工作日，一般当天/次日能完成审核），审核通过后即可立即发布版本<br />
                  </br />
                  <div>
                  </div>
                </div>
              </el-step>
            </el-steps>
          </div>
        </el-col>
        <el-col :span="8">
          <div style="height: 200px;">
            <el-button class="btn" type="primary" size="medium" @click="toAuthorization" :disabled="appStatus">{{ appStatus ? '已授权': '开始授权' }}</el-button>
            <el-button class="btn" type="primary" size="medium" @click="setPayWays">设置</el-button>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="16">
          <el-steps align-center>
            <el-step title="授权"></el-step>
            <el-step title="待提交审核"></el-step>
            <el-step title="审核中"></el-step>
            <el-step title="待发布"></el-step>
            <el-step title="已发布"></el-step>
          </el-steps>
        </el-col>
        <el-col :span="8"></el-col>
      </el-row>
    </el-card>
    <my-from-dialog :isShow="isShow" :title="'设置小程序支付方式'" @cancel="closeDialog" @ok="okDialog" @closeCallBack="closeCbDialog" :isFullscreen="false" :scrollHeight="'170px'" :dialogWidth="'600px'" :okBtnText="'设 置'">
      <template slot="froms">
        <el-form :model="payForm" :rules="payRules" ref="payForm" label-width="150px">
          <el-form-item label="appSecret(必填)" prop="appSecret">
            <el-input v-model="payForm.appSecret" placeholder="请输入API密钥" :disabled="isEidt" class="baseInp" />
            <el-button class="editBtn" type="primary" size="mini" @click="setEidtState">修改</el-button>
          </el-form-item>
          <el-form-item label="商户号ID(必填)" prop="mchId">
            <el-input v-model="payForm.mchId" placeholder="请输入商户号ID" :disabled="isEidt" class="baseInp" />
          </el-form-item>
          <el-form-item label="支付API密钥(必填)" prop="payKey">
            <el-input v-model="payForm.payKey" placeholder="请输入API密钥" :disabled="isEidt" class="baseInp" />
          </el-form-item>
          <!-- <el-form-item prop="storeName">
                  <div slot="label">证书文件</div>
                  <div>
                    <el-tooltip class="item" effect="dark" content="微信退款功能需要提供证书" placement="top">
                      <el-button icon="el-icon-info" type="text" class="infoIcon"></el-button>
                    </el-tooltip>
                  </div>
                  <el-button class="btn2" type="primary" size="mini">点击上传含cert的pem文件</el-button>
                  <p>certName:808adfcssaf1152zsccccccafdsf</p>
                  <el-button class="btn2" type="primary" size="mini">点击上传含key的pem文件</el-button>
                  <p>keyName:808adfcssaf1152zsccccccafdsf</p>
                </el-form-item> -->
        </el-form>
      </template>
    </my-from-dialog>
  </div>
</template>

<script>
let self = null;
import { objDeepCopy } from '@/utils/index';
import myFromDialog from '@/components/common/from_dialog';
export default {
  components: { myFromDialog },
  computed: {},
  watch: {},
  data() {
    return {
      isShow: false,
      isEidt: true,
      formData: {},
      payForm: {},
      loginData: {},
      rules: this.getRules(),
      appStatus: false,
      payRules: this.getPayRules()
    };
  },
  created() {
    self = this;
    this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
    this.getWeChatList();
  },
  methods: {
    toAuthorization() {
      this.getWeChatList((flag) => {
        if (!flag) {
          const { href } = self.$router.resolve({
            path: "getPreAuthorizationPage",
            // query: {
            //     id: 1
            // }
          });
          window.open(href, '_blank');
        }
      })
    },
    setEidtState() {
      this.isEidt = false;
    },
    setPayWays() {
      this.getWeChatList((flag) => {
        if (flag) {
          self.payForm = objDeepCopy(this.formData);
          self.isEidt = true;
          self.isShow = true;
          self.$nextTick(() => {
            this.$refs.payForm.clearValidate();
          })
        }
      });
    },
    closeDialog(data) {
      this.isShow = false;
    },
    closeCbDialog(data) {
      console.log(data);
      this.isShow = false;
    },
    okDialog(data) {
      let flag = false;
      this.$refs.payForm.validate(valid => {
        flag = valid;
      });
      if (!flag) return;
      this.$https.put('system/wechat', self.payForm).then(res => {
        if (res.code === 200) {
          self.$message.success('设置成功');
          self.isEidt = true;
          self.isShow = false;
          self.getWeChatList();
        }
      }).catch(res => {
        // self.$message.error('接口请求异常,请稍后再试');
      })
    },
    getWeChatList(cb) {
      this.$https.get('system/wechat/list', { enterpriseId: this.loginData.enterpriseId }).then(res => {
        if (res.code === 200) {
          if (res.rows && res.rows.length > 0) {
            self.formData = res.rows[0];
            self.appStatus = self.formData.appStatus !== 0;
            cb && cb(true);
          } else {
            if (cb) {
              cb && cb(false);
            }
          }

        } else {
          self.$message.error('接口请求异常,请稍后再试');
        }
        console.log('微信配置列表===========》', res);
      }).catch(res => {
      })
    },
    getRules() {
      return {
        enterpriseName: { required: true, message: '请选择所属药企', trigger: 'blur' },
      };
    },
    getPayRules() {
      return {
        mchId: { required: true, message: '请填写商户号ID', trigger: 'blur' },
        payKey: { required: true, message: '请填写API密钥', trigger: 'blur' },
        appSecret: { required: true, message: '请填写appSecret', trigger: 'blur' },
      };
    }
  }
};
</script>

<style lang="less" scoped>
.boxCard .clearfix {
    font-weight: bold;
}
.stepLine /deep/ .el-step__line {
    background-color: transparent;
}
.description {
    color: #a7a7a7;
    font-weight: 500;
    font-size: 14px;
}
.btn {
    display: block;
    margin-bottom: 100px;
}
.infoIcon {
    padding: 6px 0;
    font-size: 20px;
    color: #000;
}
.btn2 {
    display: block;
}
.baseInp {
    display: inline-block;
    width: 250px;
}
.editBtn {
    margin-left: 10px;
}
</style>
